import type { YesNoOption } from "@/utils";
import type { ServiceResponse } from "./api.types";
import { privateAPI } from "./axios";

export interface InsuranceResponse {
  mbi: string;
  primaryPayer: string;
  secondaryPayer: string;
  secondaryPayerId: string;
  hmo: YesNoOption;
  ppo: YesNoOption;
  planEffectiveDate: string;
  msp: {
    MSPType: string;
    policyNumber: string;
    insurerName: string;
    address1: string;
    city: string;
    state: string;
    zip: string;
    startDate: string;
    endDate: string;
  } | null;
}

export async function getPatientInsurances(
  firstName: string,
  lastName: string,
  birthdate: string,
): Promise<InsuranceResponse> {
  const { data } = await privateAPI.get<ServiceResponse<InsuranceResponse>>(
    `/patients/insurance-information`,
    {
      params: {
        firstName,
        lastName,
        dateOfBirth: birthdate,
      },
    },
  );

  return data.data;
}
